export enum partnerEnum {
    partners = 'Partner'
}